import React from 'react';
import { FormattedMessage } from 'react-intl';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';

import Select from '../common/inputs/select';
import GlassPopup from '../common/interface/glassPopup';
import CheckBox from '../common/inputs/checkBox';
import TextBox from '../common/inputs/textBox';
import ErrorFeedback from '../common/feedback/errorFeedback';

const RulesFormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    errors,
    entityNameSingular,
    popupState
  } = props;

  return (
    <GlassPopup
      className="form_popup rule_form_popup"
      type={Constants.interface.popup.types.LATERAL}
      title={(<FormattedMessage 
        id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
        values={{entityNameSingular: entityNameSingular}}
      />)}
      buttonText={(<FormattedMessage 
        id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
        values={{entityNameSingular: entityNameSingular}}
      />)}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="calendarAdmin.fields.calendar_rule"
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="name"
        labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.name"/>}
        data-path="calendar_rule.name"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.name")}
        onChange={handleOnChangeForm}
        className={("name" in errors) ? "has_error" : null}
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        id="priority"
        dataType={Constants.selectKeys.metric.dataType.NUMBER}
        labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.priority"/>}
        data-path="calendar_rule.priority"
        value={FormatTooling.preventTexboxZeroHide(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.priority"))}
        onChange={handleOnChangeForm}        
        className={("priority" in errors) ? "has_error" : null}
      />
      <div className="row_fields">
        <CheckBox 
          id="laboral"
          labelLocale={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.repetition") == Constants.selectKeys.calendar.repetitionOptions.WEEKS ? <FormattedMessage id="calendarAdmin.fields.calendar_rule.laboral"/> : <FormattedMessage id="calendarAdmin.fields.calendar_rule.laboral_years"/>}
          data-path="calendar_rule.laboral"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.laboral")}
          onChange={handleOnChangeForm}
          className={("laboral" in errors) ? "has_error" : null}
        />
        <CheckBox 
          id="override_holidays"
          labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.override_holidays"/>}
          data-path="calendar_rule.override_holidays"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.override_holidays")}
          onChange={handleOnChangeForm}
        />
      </div>
      {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.repetition") == Constants.selectKeys.calendar.repetitionOptions.WEEKS) && (
        <p className='rule_form_popup_text_label'><FormattedMessage id="calendarAdmin.fields.calendar_rule.week_days"/> ({JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.laboral") == true ? <FormattedMessage id="calendarAdmin.weekDaysLaboralLabel"/> : <FormattedMessage id="calendarAdmin.weekDaysNonLaboralLabel"/>}): &nbsp;&nbsp;
          <CheckBox 
            id="monday"
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.1"/>}
            data-path="calendar_rule.rule_hash.1"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.rule_hash.1")}
            onChange={handleOnChangeForm}
          />
          <CheckBox 
            id="tuesday"
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.2"/>}
            data-path="calendar_rule.rule_hash.2"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.rule_hash.2")}
            onChange={handleOnChangeForm}
          />
          <CheckBox 
            id="wednesday"
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.3"/>}
            data-path="calendar_rule.rule_hash.3"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.rule_hash.3")}
            onChange={handleOnChangeForm}
          />
          <CheckBox 
            id="thusrday"
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.4"/>}
            data-path="calendar_rule.rule_hash.4"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.rule_hash.4")}
            onChange={handleOnChangeForm}
          />
          <CheckBox 
            id="friday"
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.5"/>}
            data-path="calendar_rule.rule_hash.5"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.rule_hash.5")}
            onChange={handleOnChangeForm}
          />
          <CheckBox 
            id="saturday"
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.6"/>}
            data-path="calendar_rule.rule_hash.6"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.rule_hash.6")}
            onChange={handleOnChangeForm}
          />
          <CheckBox
            id="sunday"
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.7"/>}
            data-path="calendar_rule.rule_hash.7"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.rule_hash.7")}
            onChange={handleOnChangeForm}
          />
        </p>
      )}
      <div className="row_fields">
        <TextBox 
          styleType={Constants.interface.inputs.styleType.OUTLINED}
          id="repeat_every"          
          dataType={Constants.selectKeys.metric.dataType.NUMBER}
          labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.repeat_every"/>}
          data-path="calendar_rule.repeat_every"
          value={FormatTooling.preventTexboxZeroHide(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.repeat_every"))}
          onChange={handleOnChangeForm}
          className={("repeat_every" in errors) ? "has_error" : null}
        />
        <Select 
          options={InterfaceTooling.getSelectArray("selectKeys.calendar.repetitionOptions","calendarAdmin.fields.calendar_rule.repetitionOptions", false)}
          labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.repetition"/>}
          data-path="calendar_rule.repetition"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.repetition")}
          onChange={handleOnChangeForm}
          className={("repetition" in errors) ? "has_error" : null}
        />
      </div>
      {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.repetition") == Constants.selectKeys.calendar.repetitionOptions.YEARS) && (
        <React.Fragment>
          <label className="form_info">
            <FormattedMessage 
              id={"calendarAdmin.fields.calendar_rule.repeat_timesHelp"}
            />
          </label>
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            id="repeat_times"          
            dataType={Constants.selectKeys.metric.dataType.NUMBER}
            labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.repeat_times"/>}
            data-path="calendar_rule.repeat_times"
            value={FormatTooling.preventTexboxZeroHide(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.repeat_times"))}
            onChange={handleOnChangeForm}
            className={("repeat_times" in errors) ? "has_error" : null}
          />
        </React.Fragment>
      )}
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={"Constants.interface.inputs.type.TEXT"}
        id="start_date"
        data-path="calendar_rule.start_date"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.start_date")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.start_date"/>}
        dataType={Constants.textFiltersDataTypes.DATE}
        className={("start_date" in errors) ? "has_error" : null}
      />
      {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.repetition") == Constants.selectKeys.calendar.repetitionOptions.WEEKS) && (
        <TextBox 
          styleType={Constants.interface.inputs.styleType.OUTLINED}
          type={Constants.interface.inputs.type.TEXT}
          id="end_date"
          data-path="calendar_rule.end_date"
          onChange={handleOnChangeForm}
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.end_date")}
          labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.end_date"/>}
          dataType={Constants.textFiltersDataTypes.DATE}
          className={("end_date" in errors) ? "has_error" : null}       
        />
      )}
      <div className="row_fields">
        <CheckBox 
          id="is_general_rule"
          data-path="calendar_rule.is_general_rule"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.is_general_rule")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="calendarAdmin.fields.calendar_rule.is_general_rule"/>}
        />
        {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.id") && (
          <CheckBox 
            id="active"
            data-path="calendar_rule.active"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"calendar_rule.active")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
          />
        )}
      </div>
      <label className="form_info">
        <FormattedMessage 
          id={"calendarAdmin.isGeneralRuleHelp"}
        />
      </label> 
    </GlassPopup>
  );
};

export default RulesFormPopup;



// WEBPACK FOOTER //
// ./source/client/components/calendarAdmin/ruleFormPopup.jsx